import React, { CSSProperties } from 'react';
import styles from './index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import classNames from 'classnames';

export interface IContentProps {
    id: string;
    icon?: string;
    label: string;
    selected: boolean;
    onClick: (id: string) => void;
    style?: CSSProperties;
    disabled?: boolean;
}

const AnimTabContent = (props: IContentProps) => {
    const { id, icon, label, onClick, style, selected, disabled } = props;
    const handleClick = (e) => {
        if (disabled) {
            // 防止点击禁用选项关闭下拉框等区域
            e.stopPropagation();
            return;
        }
        onClick(id);
    };

    return (
        <Tooltip
            title={label}
            trigger="hover"
            placement="bottom"
        >
            <div
                className={classNames(styles.content, `anim-tab-content-${id}`, {
                    [styles['content-selected']]: selected,
                    [styles['content-disabled']]: disabled,
                })}
                onClick={handleClick}
                style={style}
            >
                <div className={styles['content-icon-area']}>
                    {icon ? <img src={icon} className={styles['content-icon-area-img']} /> : null}
                </div>
                <div className={styles['content-label-area']}>

                    <div className={styles['content-label-area-text']}>{label}</div>
                </div>
            </div>
        </Tooltip>
    );
};


export default AnimTabContent;
